import Http from "../../http/client";

export default async (payload) => {
    const response = await Http.post(`trip/driver/membership/day`, payload);

    return response.data;
}
